import { render, staticRenderFns } from "./EcocarotidiEditComponent.vue?vue&type=template&id=79488248&scoped=true"
import script from "./EcocarotidiEditComponent.vue?vue&type=script&lang=js"
export * from "./EcocarotidiEditComponent.vue?vue&type=script&lang=js"
import style0 from "./EcocarotidiEditComponent.vue?vue&type=style&index=0&id=79488248&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79488248",
  null
  
)

export default component.exports